import React from 'react'
import { LOCALE } from '../../../../constants/activity-constants'
import { StaticImage } from 'gatsby-plugin-image'
import AnimationRewards from '../../../atoms/animation-rewards/animation-rewards'

export function PremiosByLocale() {
  if (LOCALE === 'es-DO') {
    return (
      <StaticImage
        src="../../../../assets/images/tabs-section/rewards-image-do.png"
        alt="premios republica dominicana"
        placeholder="blurred"
        className="tab-content__animation__image"
      />
    )
  }
  if (LOCALE === 'es-PR') {
    return (
      <StaticImage
        src="../../../../assets/images/tabs-section/rewards-image-pr.png"
        alt="premios puerto rico"
        placeholder="blurred"
        className="tab-content__animation__image"
      />
    )
  }
  if (LOCALE === 'es-BO') {
    return (
      <StaticImage
        src="../../../../assets/images/tabs-section/rewards-image-bo.png"
        alt="premios puerto rico"
        placeholder="blurred"
        className="tab-content__animation__image"
      />
    )
  }
  if (LOCALE === 'es-PE') {
    return (
      <div>
        <AnimationRewards type={2} />
        <p className="--text-imgref ">*Imágenes de referencias</p>
        <br />
      </div>
    )
  }
  if (LOCALE === 'es-AR') {
    return (
      <div>
        <AnimationRewards type={2} />
        <p className="--text-imgref ">*Imágenes ilustrativas</p>
        <br />
      </div>
    )
  }
  if (LOCALE === 'es-PY') {
    return (
      <>
        <StaticImage
          src="../../../../assets/images/tabs-section/rewards-image-py.png"
          alt="premios Paraguay"
          placeholder="blurred"
          className="tab-content__animation__image"
        />
        <p className="--text-imgref ">*Imágenes ilustrativas</p>
        <br />
      </>
    )
  }
  return <AnimationRewards type={2} />
}
export function rewardsTextByLocale() {
  if (LOCALE === 'es-PY') {
    return (
      <>
        <b>Del top 1 al 10 ganarán</b> 1 Kit con Productos
        <br /> y un Mouse Pad de la marca
        <br />
      </>
    )
  }
  if (LOCALE === 'es-PE') {
    return (
      <>
        <span>El primer puesto ganará</span> una cámara instantánea <br />
        <br />
        <span> El segundo puesto ganará</span> un rizador de cabello <br />
        <br />
        <span>El tercer puesto ganará </span>un audífonos JBL
        <br />
        <br />
        <span> Del top 4 al 10 ganarán</span> 1 Pack de productos Nosotras.
        <br />
      </>
    )
  }
  if (LOCALE === 'es-CL') {
    return (
      <>
        <span>Del top 1 al 3 ganarán</span> 1 kit de Productos + 1 estuche de
        Lápices.
        <br />
        <br />
        <span> Del top 4 al 10 ganarán</span> 1 kit de Productos + 1 libreta.
        <br />
      </>
    )
  }
  //
  if (LOCALE === 'es-DO') {
    return (
      <>
        <span>Del top 1 al 5 ganarán</span> 1 cepillo desenredante <br />+ 1 Kit
        de Productos Nosotras
        <br />
        <br />
      </>
    )
  }
  //
  if (LOCALE === 'es-PR') {
    return (
      <>
        <span>Del top 1 al 2 ganarán</span> 1 Kit de Productos Nosotras
        <br />
        <br />
      </>
    )
  }

  if (LOCALE === 'es-BO') {
    return (
      <>
        <span>Del top 1 al 5 ganarán</span> un pack de wallpapers de la
        actividad
        <br />
        <br />
      </>
    )
  }
  if (LOCALE === 'es-AR') {
    return (
      <>
        <span>Del top 1 al 5 ganarán</span> 1 año de productos <br /> Nosotras +
        una botella y un cuaderno
        <br />
        <br />
        <span>Del top 6 al 15 ganarán</span> 1 Kit de Productos <br /> Nosotras
        + una botella y un cuaderno
        <br />
        <br />
      </>
    )
  }
  // DEFAULT
  return (
    <>
      <span>Del top 1 al 3 ganarán</span> un Cepillo <br /> Alisador + 1 Kit de
      Productos Nosotras.
      <br />
      <br />
      <span> Del top 4 al 10 ganarán</span> 1 Kit de <br /> Productos Nosotras.
      <br />
    </>
  )
}

export function rewardsTabText() {
  if (LOCALE === 'es-AR') {
    return (
      <>
        Antes de jugar, conoce todos los
        <br /> términos y condiciones{' '}
      </>
    )
  }
  return (
    <>
      Antes de jugar, conoce todos los <br /> términos y condiciones{' '}
    </>
  )
}
